import React, { useEffect, useRef, useState } from 'react';
import { TransformWrapper, TransformComponent, ReactZoomPanPinchRef } from 'react-zoom-pan-pinch';

interface ZoomableImageProps {
    src: string;
    alt?: string;
}

const ZoomableImage: React.FC<ZoomableImageProps> = ({ src, alt = '' }) => {
    const transformRef = useRef<ReactZoomPanPinchRef>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const [initialScale, setInitialScale] = useState(1);

    useEffect(() => {
        const fitImageToContainer = () => {
            const img = new Image();
            img.src = src;

            img.onload = () => {
                if (containerRef.current) {
                    const containerWidth = containerRef.current.clientWidth;
                    const containerHeight = containerRef.current.clientHeight;

                    const scaleX = containerWidth / img.width;
                    const scaleY = containerHeight / img.height;

                    const scale = Math.min(scaleX, scaleY);

                    setInitialScale(scale);

                    if (transformRef.current) {
                        transformRef.current.zoomToElement('target-image', scale);
                    }
                }
            };
        };

        fitImageToContainer();
    }, [src]);

    return (
        <div
            ref={containerRef}
            style={{
                width: '100%',
                height: '100%',
                overflow: 'hidden'
            }}
        >
            <TransformWrapper
                initialScale={initialScale}
                minScale={initialScale * 0.5}
                maxScale={5}
                ref={transformRef}
                centerOnInit={true}
            >
                <TransformComponent
                    wrapperStyle={{
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <img
                        id="target-image"
                        src={src}
                        alt={alt}
                        style={{
                            width: 'auto',
                            height: 'auto',
                            maxWidth: 'none',
                            maxHeight: 'none',
                            display: 'block',
                        }}
                    />
                </TransformComponent>
            </TransformWrapper>
        </div>
    );
};

export default ZoomableImage;